import { zipCodeError, ZipCodeResponse } from './types';

type zipCodeApi = (_zipCode: string) => Promise<ZipCodeResponse>

export const fetchZipCode: zipCodeApi = async zipCode => {
    try {
        const response = await fetch(
            `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`
        );
        return await response.json();
    } catch (error) {
        throw zipCodeError(error.message);
    }
};
